import { render, staticRenderFns } from "./IncomeTaxCalculator.vue?vue&type=template&id=9c677254&scoped=true"
import script from "./IncomeTaxCalculator.vue?vue&type=script&lang=ts"
export * from "./IncomeTaxCalculator.vue?vue&type=script&lang=ts"
import style0 from "./IncomeTaxCalculator.vue?vue&type=style&index=0&id=9c677254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c677254",
  null
  
)

export default component.exports